class CountdownCarousalTimer extends HTMLElement {
  constructor() {
    super();
    this.timerId = 'cd_timer';
  }

  connectedCallback() {
    const endDate = this.dataset.endDate;
    const endTime = this.dataset.endTime;
    const hideCountdown = this.dataset.hideCountdown === 'true';

    if (!endDate || !endTime) {
      console.error('Missing data-end-date or data-end-time attribute.');
      return;
    }

    const deadline = new Date(`${endDate} ${endTime}`);
    this.initCountdown(deadline, hideCountdown);

    // Hide the countdown-colletion initially
    const collection = this.querySelector('.countdown-colletion');
    if (collection) collection.style.display = 'none';
  }

  getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    return { total, days, hours, minutes, seconds };
  }

  initCountdown(endtime, hideCountdown) {
    let clock = this.querySelector(`#${this.timerId}`);
    let daysSpan = clock.querySelector('.s_days');
    let hoursSpan = clock.querySelector('.s_hours');
    let minutesSpan = clock.querySelector('.s_minutes');
    let secondsSpan = clock.querySelector('.s_seconds');

    const updateClock = () => {
      let t = this.getTimeRemaining(endtime);

      if (t.total <= 0) {
        if (daysSpan) daysSpan.innerHTML = 0;
        if (hoursSpan) hoursSpan.innerHTML = '00';
        if (minutesSpan) minutesSpan.innerHTML = '00';
        if (secondsSpan) secondsSpan.innerHTML = '00';

        this.classList.add('zero-count');

        if (hideCountdown) {
          const content = this.querySelector('.countdown-content');
          if (content) content.style.display = 'none';
          const countdownBanner = this.closest('.new-countdown-banner');
          const link_hover = countdownBanner.querySelector('.for_count_down_hidden');
          link_hover.style.display = 'flex';
          
          const signupForm = this.nextElementSibling;
          if (signupForm && signupForm.classList.contains('signup-form')) {
              link_hover.style.display = 'none';
          }
          this.classList.add('countdown-hidden-with-zero');
        }
        const collection = this.querySelector('.countdown-colletion');
        if (collection) collection.style.display = 'block';


        clearInterval(interval);
      } else {
        if (daysSpan) daysSpan.innerHTML = t.days;
        if (hoursSpan) hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
        if (minutesSpan) minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
        if (secondsSpan) secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
      }
    };

    updateClock(); // Run once at start
    let interval = setInterval(updateClock, 1000);

    // Store interval as a property of the element instance
    this.interval = interval;
  }

  disconnectedCallback() {
    // Clear the interval when the element is removed from the DOM
    clearInterval(this.interval);
  }
}

customElements.define('countdown-carousal-timer', CountdownCarousalTimer);
